/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import React from 'react';

import {SnackConfig} from '@dvrd/dvr-controls';

import {showSnackbar} from '@dvrd/dvr-controls';

export function onShowConfirmSnackbar(message: string | React.ReactElement, config?: SnackConfig) {
    const defaultConfig: SnackConfig = {backgroundColor: 'color-green-whatsapp', textColor: 'white'};
    showSnackbar(message, {...defaultConfig, ...config});
}
